import React, { useMemo } from "react";
import { I18nextProvider } from "react-i18next";

import i18n from "../../../i18n";

import { usePricing } from "../../../contexts/PricingContext";
import { useQuote } from "../../../hooks/useQuote";
import QuoteForm from "../../../components/quote/QuoteForm";
import QuoteSummary from "../../../components/quote/QuoteSummary";

/** Mesmo motor e mesmos componentes da página pública, em tema escuro. */
export default function SimulatorTab() {
  const { data, places, extras, zoneNames, zones } = usePricing();
  const quote = useQuote(data);
  // O painel é sempre em português, independentemente do idioma escolhido no site.
  const adminI18n = useMemo(() => i18n.cloneInstance({ lng: "pt" }), []);

  return (
    <I18nextProvider i18n={adminI18n}>
    <div className="grid gap-4 lg:grid-cols-[1fr_20rem] lg:items-start">
      <QuoteForm
        quote={quote}
        config={data.config}
        places={places}
        extras={extras}
        zoneNames={zoneNames}
        zoneOrder={zones.map((z) => z.id)}
        tone="dark"
        showContact={false}
      />
      <QuoteSummary quote={quote} config={data.config} tone="dark" showActions={false} className="lg:sticky lg:top-4" />
    </div>
    </I18nextProvider>
  );
}
